import InnerNetworkComponent from './inner-network-component'

const NetworkComponent = ({ courseId, preAnalyticData, surveyId }) => {
  if (!preAnalyticData) return null

  const filterPreAnalyticData = preAnalyticData.find(
    data => parseInt(data.courseId, 10) === courseId
  )

  const sociogramId = filterPreAnalyticData.surveyId.sociogram_id

  return (
    <div className='inner-network-component'>
      <InnerNetworkComponent
        sociogramId={sociogramId}
        filterPreAnalyticData={filterPreAnalyticData}
        courseId={courseId}
        surveyId={surveyId}
      />
    </div>
  )
}

export default NetworkComponent
